import * as React from 'react'

import { Return } from 'modules/core/lib/asyncAction'

import type SurveyForm from 'modules/surveys/store/models/Form'
import type Survey from 'modules/surveys/store/models/v2/Survey'

export const analyticsContext: React.Context<any> = React.createContext({})

export const useAnalytics = () => React.useContext(analyticsContext)

interface ContextProps {
  form: SurveyForm | null | undefined
  survey: Survey | null | undefined
  hasSurveyV2: boolean
  canbeStarted: boolean
  isAnonymous: boolean
  updateCanBeStarted: () => Promise<Return<void>>
  canEditSurvey: boolean
  loading: boolean
}

export const SurveyShowContext = React.createContext<ContextProps | null>(null)

export const useSurveyShowContext = () => {
  const context = React.useContext(SurveyShowContext)

  if (!context) {
    throw new Error('SurveyShowContext must be within its provider')
  }

  return context
}
